import { BaseService } from './BaseService'
const CONVERTED_AWARD_PATH = '/my-converted-awards'
class DonatedService extends BaseService {
  getDonatedList () {
    return this.get(CONVERTED_AWARD_PATH)
  }

  getConvertedAwardCode (awardUserId) {
    return this.get(`${CONVERTED_AWARD_PATH}/${awardUserId}/code`)
  }
}
export default new DonatedService()
